export const unscheduleReasons = [
  { value: "Enfant malade", name: "Enfant malade" },
  { value: "Congés payés", name: "Congés payés" },
  { value: "Changement de planning", name: "Changement de planning" },
  { value: "Maladie", name: "Maladie" },
  { value: "Exclusion formateur", name: "Exclusion formateur" },
  { value: "Départ société", name: "Départ société" },
  { value: "Annulation par l’organisme", name: "Annulation par l’organisme" },
  { value: "Annulation par l’équipe RH", name: "Annulation par l’équipe RH" },
  { value: "Non justifié", name: "Non justifié" },
  { value: "Autre", name: "Autre" },
];
